module.exports = __webpack_public_path__ + "static/media/mpg.44627e09.svg";